import { NgModule } from '@angular/core';
import { TasaCambioResolver } from './tasa-cambio.resolver';
import { WsGlobalService } from '../http/ws-global.service';

@NgModule({
    providers: [
        WsGlobalService,
        TasaCambioResolver
    ]
})
export class CiptechResolvers { }
